// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum TemplateDesignFieldType {
	Field = 1,
	ConditionalField = 2,
	RepeatableField = 3,
	RelatedSchema = 4,
	EmailAttachment = 5,
}
